import React from 'react';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import InputTextComponent from '../components/inputs/InputTextComponent';
import TrailerModel from '../model/TrailerModel';
import DivContainer from '../components/DivContainer';
import {ActionButton} from '../components/ActionButton';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import TrailerService from '../services/TrailerService';

class TrailerDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new TrailerService());
        this.state = {
            elementId: props.elementId,
            element: new TrailerModel(),
            viewMode: this.props.viewMode,
        };
        this.handleDelete = this.handleDelete.bind(this);
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'>
                    {this.state.viewMode === 'EDIT' ? (
                        <ActionButton
                            label={t('trailer.deleteButton')}
                            variant='button cancel-button red'
                            handleClick={(e) => {
                                if (e) {
                                    e.preventDefault();
                                }
                                this.setState({viewMode: 'DELETE', closable: false});
                            }}
                        />
                    ) : null}
                </div>
                <ActionButton
                    label={t('details.cancel')}
                    variant={this.state.viewMode === 'DELETE' ? 'button cancel-button red' : 'button cancel-button white'}
                    handleClick={this.props.onHide}
                />
                <ActionButton
                    label={this.state.viewMode === 'NEW' ? t('trailer.addButton') : t('trailer.editButton')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
                <ActionButton
                    label={t('details.deleteConfirmationButton')}
                    variant='button save-button fullred'
                    handleClick={this.handleDelete}
                    rendered={this.state.viewMode === 'DELETE'}
                />
            </div>
        );
    }
    handleDelete(e) {
        if (e) {
            e.preventDefault();
            const {t} = this.props;
            this.blockUi();
            this.service
                .delete(this.state.element)
                .then((response) => {
                    this.persistMessage('success', '', t('trailer.deleteSuccess'));
                    this.unblockUi();
                    if (this.props.afterSave) {
                        this.props.afterSave();
                    }
                })
                .catch((err) => {
                    this.persistMessage('error', '', t('error.trailerDeleteError'));
                    this.unblockUi();
                    if (this.props.afterSave) {
                        this.props.afterSave();
                    }
                });
        }
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('trailer.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                            ? `${t('trailer.editHeader')}`
                            : `${t('trailer.deleteHeader')}`}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: TrailerModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    getContainerListName() {
        return 'trailer-list-container';
    }

    getAddSucces() {
        const {t} = this.props;

        return t('trailer.addSuccess');
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('trailer.updateSuccess');
    }
    createOrUpdate() {
        const {element} = this.state;
        const {t} = this.props;
        this.scrollToTop();
        if (this.props._isMounted) {
            this.blockUi();
            if (element.sapId === undefined || element.sapId === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        // this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        this.unblockUi();
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.persistMessage('error', '', t('error.trailerAddError'));
                        this.unblockUi();
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        //this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        this.unblockUi();
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.persistMessage('error', '', err.message);
                        this.unblockUi();
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    });
            }
        }
    }

    renderDetails() {
        const {t} = this.props;
        return this.state.viewMode === 'DELETE' ? (
            <DivContainer>
                <label id={`delete-driver-label-id`} className='p-label' htmlFor={'delete-driver'} style={{width: '100%'}}>
                    {t('details.deleteConfirmation')}
                </label>
                <span
                    aria-label={t('details.deleteConfirmation')}
                    aria-labelledby={`delete-driver--label-id`}
                    className={`p-inputtext-view icon_text element-to-remove`}
                >
                    {this.state.element.registrationNumber}
                </span>
            </DivContainer>
        ) : (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='registrationNumber'
                        name='registrationNumber'
                        label={t('trailer.registrationNumber')}
                        colClass='col-md-6'
                        value={this.state.element.registrationNumber}
                        validator={this.validator}
                        validators='required|alpha_num|max:10'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        forceUpperCase
                        keyfilter={/^[A-Z0-9]*$/i}
                    />

                    <InputRadioButtonComponent
                        id='type'
                        name='type'
                        colClass='col-md-6'
                        viewMode='EDIT'
                        options={this.props.typeOptions}
                        value={this.state.element.type}
                        validator={this.validator}
                        valueLabel='label'
                        labelOnRight
                        valueKey='enumValue'
                        itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                        onChange={this.handleChange}
                        label={t('trailer.type')}
                        validators='required'
                    />
                </DivContainer>
                <DivContainer colClass='row'>
                    <InputCheckboxComponent
                        id={`own`}
                        name='own'
                        label={t('trailer.isNotOwn')}
                        labelOnRight
                        value={this.state.element.own}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        validators='not_required'
                        negated
                    />
                </DivContainer>
            </React.Fragment>
        );
    }
}

TrailerDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

TrailerDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
};

export default withTranslation()(TrailerDialog);
